import { RestrictedWordPolicy } from './restrictedWordsTypes';
import { ShowToastPayload } from '../../../../components/toast/toastTypes';

export const GLOBAL_GROUP_ID = -1;
export const GLOBAL_GROUP_NAME = 'Globally Applied';

export const UNDO_TOAST_MESSAGE_PAYLOAD: ShowToastPayload = {
  type: 'success',
  message: 'Changes cancelled'
};

export const WORDS_SEPARATOR = ',';

export const DEFAULT_WORD_POLICY: RestrictedWordPolicy = RestrictedWordPolicy.PUBLISH_AND_MODERATE;
